import { render } from "./WrongDataModal.vue?vue&type=template&id=7f42912f&ts=true"
import script from "./WrongDataModal.vue?vue&type=script&lang=ts"
export * from "./WrongDataModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__